export default {
    state: {
        filterData: {},
        isApplyingFilters: false,
        filterQuery: '',
    },

    mutations: {
        SET_FILTERS(state, filters) {
          state.filterData = filters;
        },

        SET_FILTER_QUERY(state, query) {
            state.filterQuery = query;
        },

        SET_IS_APPLYING_FILTER(state, flag) {
          state.isApplyingFilters = flag;
        },

        SET_IS_FILTER_QUERY(state, flag) {
            state.isFilterQuery = flag;
        }
    },

    actions: {
        // set the filters
        setFilters({commit}, filters) {
            commit('SET_FILTERS', filters);
        },

        // clear filters
        clearFilters({commit}) {
            commit('SET_FILTERS', {});
        },

        // set if should apply filters or not
        setApplyingFilter({commit}, flag) {
            commit('SET_IS_APPLYING_FILTER', flag);
        },

        // set the filter query
        setFilterQuery({commit}, query) {
            commit('SET_FILTER_QUERY', query);
        },

        // clear filter query
        clearFilterQuery({commit}) {
            commit('SET_FILTER_QUERY', '');
        },
    }
};